<div class="features-info-container">
    <h3 class="layer-list-title">Map Layers Toggle</h3>
    <div class="layer-list" #layerList></div>
    <div class="layer-list-legend" #layerListLegend></div>
</div>